export const initialApplicantDetails = {
  applicantName: "",
  emailId: "",
  contactNumber: "",
  alternateContactNumber: "",
  resumesource: "",
  skillDetails: [],
  certification: [],
  customFieldsArray: [],
  Applicants: {
    firstName: "",
    lastName: "",
    contactNumber: "",
    alternateContactNumber: "",
    emailId: "",
  },
  educationDetails: [
    { id: "", education: "", startDate: null, endDate: null, location: "" },
  ],
  workExp: [
    {
      id: "",
      organization: "",
      jobTitle: "",
      industry: "",
      startDate: null,
      endDate: null,
      isCurrent: "",
      location: "",
      jobDescription: "",
    },
  ],
  formattedLocation: null,
  locationCity: null,
  locationCountry: null,
  locationState: null,
  locationRawInput: null,
  latitude: null,
  longitude: null,
  totalExperience: null,
  linkedIn: "",
  id: 0,
  userId: "",
  customFields: "",
  firstName: "",
  lastName: "",
  identifier: "",
  applicantCode: "",
  customerId: 0,
  source: "ATS",
  resumesourceId: "",
  candidateStatus: "",
  csAssociatedJobs: "",
  eAssociatedJobs: "",
  vsAssociatedJobs: "",
  Resume: null,
  rawData: "",
};

export const applicantCardTypeEnum = {
  LIST: "list",
  LIST_WITH_JUSTIFY: "list-with-justify",
  LIST_WITH_COLUMN: "list-with-column",
  CUSTOM_LAYOUT: "custom-layout",
};

export const applicantCardTitleEnum = {
  WORK_EXP: "workExp",
  EDUCATION_DETAILS: "educationDetails",
  CUSTOM_FIELDS_ARRAY: "customFieldsArray",
  CERTIFICATION: "certification",
  SKILL_DETAILS: "skillDetails",
  ASSOCIATED_JOBS: "associatedJobs",
  ASSOCIATED_APPLICANTS: "associatedApplicants",
  DOCUMENTS: "documents",
  NOTES: "notes",
  AUDITLOG_DATA: "auditlogData",
};

export const jobPostingCardTypeEnum = {
  LIST_WITH_COLUMN: "list-with-column",
  COMPONENT: "component",
  DATA: "data",
  LIST: "list",
  LIST_WITH_GROUP: "list-with-group",
  LIST_WITH_LABEL: "list-with-lable",
  LIST_WITH_CARD: "list-with-card",
  CUSTOM_LAYOUT: "custom-layout",
  TABLE: "table",
  SERIAL_NUMBER_LIST: "serial-number-list",
};

export const jobPostingCardTitleEnum = {
  RECRUITING_TEAM: "Recruiting Team",
  RECRUITER_CONTRIBUTION: "Recruiter Contribution",
  CANDIDATE_STATUS: "Candidate Status",
  JOB_DESC: "Job Description",
  JOB_DESC_FOR_SM: "Job Description For Social Media",
  ADDITIONAL_INFORMATION: "Additional Information",
  SKILLS: "Skills",
  CLIENT_DETAILS: "Client Details",
  SCREENING_QUESTIONS: "Screening Questions",
  PORTALS: "Portals",
  DOCUMENTS: "Documents",
  NOTES: "Notes",
  AUDIT_INFO: "Audit Info",
};

export const systemRoles = [
  "Super Admin",
  "Admin",
  "Manager",
  "Standard User",
  "Field Recruiter",
];

export const placeholders = {
  JOBCODE: /@{JobOpenings.jobCode}@/gi,
  JOBTITLE: /@{JobOpenings.jobTitle}@/gi,
  JOBSTATUS: /@{JobOpenings.jobStatus}@/gi,
  JOBTYPE: /@{JobOpenings.jobType}@/gi,
  LOCATION: /@{JobOpenings.location}@/gi,
  PAYBILLRATE: /@{JobOpenings.payBillRate}@/gi,
  PRIMARYSKILLS: /@{JobOpenings.primarySkills}@/gi,
  WORKMODEL: /@{JobOpenings.workModel}@/gi,
  JOBDESCFORSM: /@{JobOpenings.jobDescForSM}@/gi,
  JOBDESC: /@{JobOpenings.jobDesc}@/gi,
  SECONDARYSKILLS: /@{JobOpenings.secondarySkills}@/gi,
  PRIORITY: /@{JobOpenings.priority}@/gi,
  APPLICANT: /@{Applicants.fullName}@/gi,
  APPLICANTCODE: /@{Applicants.applicantCode}@/gi,
  CONTACTNUMBER: /@{Applicants.contactNumber}@/gi,
  EMAILID: /@{Applicants.emailId}@/gi,
  EDUCATIONDETAILS: /@{Applicants.educationDetails}@/gi,
  SKILLDETAILS: /@{Applicants.skillDetails}@/gi,
  CERTIFICATION: /@{Applicants.certification}@/gi,
  WORKEXP: /@{Applicants.workExp}@/gi,
  TOTALEXP: /@{Applicants.totalExperience}@/gi,
  APPLICANTLOCATION: /@{Applicants.location}@/gi,
  CANDIDATESTATUS: /@{Applicants.candidateStatus}@/gi,
  SOURCE: /@{Applicants.source}@/gi,
  CLIENTNAME: /@{Clients.clientName}@/gi,
  ENDCLIENTNAME: /@{Clients.endClientName}@/gi,
  REGION: /@{Clients.region}@/gi,
  STATUS: /@{Clients.status}@/gi,
  MANAGEREMAIL: /@{Clients.managerEmail}@/gi,
  HIRINGMANAGER: /@{Clients.hiringManagerName}@/gi,
  HIRINGMANAGEREMAIL: /@{Clients.hiringManagerEmailId}@/gi,
  USERFIRSTNAME: /@{User.firstName}@/gi,
  USERLASTNAME: /@{User.lastName}@/gi,
  ALIASNAME: /@{User.aliasName}@/gi,
  USEREMAILID: /@{User.emailId}@/gi,
  USEREPHONENUMBER: /@{User.phoneNumber}@/gi,
};

export const placeholdersKeyNames = {
  "JobOpenings.jobCode": "Job Code",
  "JobOpenings.jobTitle": "Job Title",
  "JobOpenings.jobStatus": "Job Status",
  "JobOpenings.jobType": "Job Type",
  "JobOpenings.location": "Location",
  "JobOpenings.payBillRate": "Pay rate/Salary",
  "JobOpenings.primarySkills": "Primary Skills",
  "JobOpenings.workModel": "Work Model",
  "JobOpenings.jobDescForSM": "Job Description For Social Media",
  "JobOpenings.jobDesc": "Job Description",
  "JobOpenings.secondarySkills": "Secondary Skills",
  "JobOpenings.priority": "Priority",
  "Applicants.fullName": "Applicant Name",
  "Applicants.applicantCode": "Applicant Code",
  "Applicants.contactNumber": "Contact Number",
  "Applicants.emailId": "E-mail ID",
  "Applicants.educationDetails": "Education Details",
  "Applicants.skillDetails": "Skill Details",
  "Applicants.certification": "Certification",
  "Applicants.workExp": "Work Experience",
  "Applicants.candidateStatus": "Candidate Status",
  "Applicants.source": "Source",
  "Applicants.totalExperience": "Total Experience",
  "Applicants.location": "Location",
  "Clients.clientName": "Client's Name",
  "Clients.endClientName": "End Client's Name",
  "Clients.region": "Client's Region",
  "Clients.status": "Client's Status",
  "Clients.managerEmail": "Manager's E-mail ID",
  "Clients.hiringManagerName": "Hiring Manager's Name",
  "Clients.hiringManagerEmailId": "Hiring Manager's E-mail ID",
  "User.firstName": "First Name",
  "User.lastName": "Last Name",
  "User.aliasName": "Alias Name",
  "User.emailId": "User E-mail ID",
  "User.phoneNumber": "Phone Number",
};

// JD Parsing related constants
export const jdfieldParsingkeyEnums = {
  opening: "Opening",
  experience: "Experience",
  experienceRequired: "Experience",
  jobDescription: "Job Description",
  jobDesc: "Job Description",
  responsibilities: "Responsibilities",
  jobResponsibilities: "Responsibilities",
  requirements: "Requirements",
  projectSummary: "Project summary",
  location: "Location",
  keyskillsMustHave: "Keyskills - Must Have",
  keyskillsNiceToHave: "Keyskills - Nice to Have",
  keyskills: "Keyskills",
  skillsRequired: "Skills Required",
  qualifications: "Qualifications",
  education: "Education",
  expectedAndDesiredSkills: "Expected and Desired Skills",
  jobType: "Job Type",
  positionType: "Position Type",
};

export const JD_FIELD_ENUMS = {
  opening: "Opening",
  experience: "Experience",
  experienceRequired: "Experience",
  jobDescription: "Job Description",
  jobDesc: "Job Description",
  responsibilities: "Responsibilities",
  jobResponsibilities: "Responsibilities",
  requirements: "Requirements",
  projectSummary: "Project summary",
  location: "Location",
  keyskillsMustHave: "Keyskills - Must Have",
  keyskillsNiceToHave: "Keyskills - Nice to Have",
  keyskills: "Keyskills",
  skillsRequired: "Skills Required",
  qualifications: "Qualifications",
  education: "Education",
  expectedAndDesiredSkills: "Expected and Desired Skills",
  jobType: "Job Type",
  positionType: "Position Type",
  AboutUs: "About Us",
  About: "About Us",
  JobSummary: "Job Summary",
  PayRange: "Pay Range",
  WorkModel: "Work Model",
};

// 1. Centralized Master Skill List (can be extended or loaded externally)
export const skillList = [
  // Core Web Technologies
  "HTML",
  "HTML5",
  "CSS",
  "CSS3",
  "SASS",
  "LESS",
  "JavaScript",
  "TypeScript",
  "ES6",
  "JSON",
  "XML",
  "REST",
  "GraphQL",
  // Frontend
  "React",
  "React.js",
  "Redux",
  "Zustand",
  "Next.js",
  "Vue.js",
  "Nuxt.js",
  "Angular",
  "Svelte",
  "Bootstrap",
  "Tailwind CSS",
  "Material-UI",
  "Ant Design",
  "Chakra UI",
  "Styled Components",
  "jQuery",
  "Webpack",
  "Vite",
  "Parcel",
  // Backend
  "Node.js",
  "Express.js",
  "NestJS",
  "Koa",
  "Hapi",
  "Django",
  "Flask",
  "Spring Boot",
  "ASP.NET",
  "Laravel",
  "PHP",
  "Python",
  "Java",
  "C#",
  "C++",
  "Go",
  "Ruby on Rails",
  // Databases
  "MySQL",
  "PostgreSQL",
  "MongoDB",
  "SQLite",
  "Redis",
  "MariaDB",
  "Oracle",
  "Firebase",
  "Supabase",
  "DynamoDB",
  "Cassandra",
  // Cloud & DevOps
  "AWS",
  "Azure",
  "Google Cloud Platform",
  "Docker",
  "Kubernetes",
  "Jenkins",
  "Terraform",
  "GitHub Actions",
  "CI/CD",
  "Ansible",
  "Linux",
  "Nginx",
  "Apache",
  "Vercel",
  "Netlify",
  // Security & Testing
  "JWT",
  "OAuth2",
  "CORS",
  "SSL",
  "Penetration Testing",
  "Unit Testing",
  "Jest",
  "Mocha",
  "Chai",
  "Cypress",
  "Playwright",
  "Selenium",
  "Postman",
  "Swagger",
  "API Testing",
  // Mobile
  "React Native",
  "Flutter",
  "Swift",
  "Kotlin",
  "Android Studio",
  "Xcode",
  "Ionic",
  "Cordova",
  // Data & Analytics
  "SQL",
  "Excel",
  "Power BI",
  "Tableau",
  "Pandas",
  "NumPy",
  "Matplotlib",
  "TensorFlow",
  "PyTorch",
  "Machine Learning",
  "Deep Learning",
  "Data Visualization",
  // AI/ML/NLP
  "OpenCV",
  "Scikit-learn",
  "NLP",
  "LangChain",
  "LLMs",
  "Hugging Face",
  "Generative AI",
  // UI/UX & Design
  "Figma",
  "Adobe XD",
  "Sketch",
  "Photoshop",
  "Illustrator",
  "Canva",
  "Wireframing",
  "Prototyping",
  "WCAG",
  "Accessibility",
  "Responsive Design",
  // Project Management
  "Agile",
  "Scrum",
  "Kanban",
  "JIRA",
  "Confluence",
  "Trello",
  "Slack",
  "Notion",
  "Waterfall",
  "Project Planning",
  // Communication/Collab
  "Git",
  "GitHub",
  "GitLab",
  "Bitbucket",
  "Version Control",
  "Team Collaboration",
  "Documentation",
  "Code Review",
  // Tools & Misc
  "Babel",
  "ESLint",
  "Prettier",
  "Storybook",
  "Redux Toolkit",
  "NPM",
  "Yarn",
  "RESTful APIs",
  "Server-Side Rendering (SSR)",
  "Static Site Generation (SSG)",
  "Microservices",
  "GraphQL APIs",
  "Responsive Web Design",
  "Performance Optimization",
];

export const HEADINGS = [
  "Job Title",
  "Role",
  "Position",
  "TITLE",
  "Job Type",
  "Position Type",
  "Work Model",
  "Project summary",
  "Job Description",
  "Job Desc",
  "Requirements",
  "Job Responsibilities",
  "Responsibilities",
  "About Us",
  "About",
  "Pay Range",
  "Location",
  "Experience",
  "Experience Level",
  "Education",
  "Qualifications",
  "Soft Skills",
  "Preferred Qualifications",
  "Skills Needed",
  "Keyskills - Must Have",
  "Keyskills - Nice to Have",
  "Keyskills",
  "Skills Required",
  "Skills Needed",
  "Primary Skills",
  "Technical Skills",
  "Key skills",
  "Expected and Desired Skills",
  "Required Skills",
  "Qualifications",
  "Salary",
  "Job Summary",
  "Reports To",
  "Opening",
];

export const protectedExtensions = [
  ".js",
  ".ts",
  ".php",
  ".json",
  ".css",
  ".html",
  ".xml",
  ".md",
];

export const JDkeysToMap = [
  "Role",
  "Opening",
  "Experience",
  "Job Description",
  "Job Desc",
  "Responsibilities",
  "Requirements",
  "Job Responsibilities",
  "Project summary",
  "Location",
  "Keyskills - Must Have",
  "Keyskills - Nice to Have",
  "Keyskills",
  "Skills Required",
  "Qualifications",
  "Education",
  "About Us",
  "About",
  "Required Skills",
  "Pay Range",
  "Work Model",
  "Expected and Desired Skills",
  "Skills Needed",
  "Primary Skills",
  "Technical Skills",
  "Soft Skills",
  "Preferred Qualifications",
  "Experience Level",
  "Job Summary",
  "Opening",
  "About the role",
];

export const warningPopups = {
  DELETE_ASSOCIATE_POPUP: {
    title: "Are you sure you want to delete ?",
    btnName: "Delete",
    type: "delete",
  },
  DELETE_POPUP: {
    title: "Are you sure you want to delete this Job Posting?",
    title1: "This action cannot be undone.",
    btnName: "Delete",
    type: "delete",
  },
  CLONE_POPUP: {
    title: "Are you sure you want to clone ?",
    btnName: "Yes",
    type: "clone",
  },
};

export const reportTypesEnum = {
    CANDIDATE: 'Candidate Reports',
    CLIENT: 'Client Reports',
    JOB: 'Job Reports',
};